<template>
  <div style="width: 100%">
    <mx-panel v-if="!IsDelete && value" :type="config.Type" :value="value" :config="Config" panel="SystemList2" :selected="selected" :index="index" @event="OnEvent">
      <template>
        <div class="flex-row" style="width: 100%">
          <div class="wf left" style="color: #878a99">名称</div>
          <div class="wf left" style="color: #878a99">关联试卷</div>
          <div class="wf left" style="color: #878a99">关联培训</div>
          <div class="w200 left" style="color: #878a99">及格分数</div>
          <div class="w200 left" style="color: #878a99">考试人员数量</div>

          <div class="w200 left" style="color: #878a99">创建时间</div>
          <div class="wf left" style="color: #878a99">操作</div>
        </div>
      </template>
      <template slot="content">
        <div class="flex-row start middle border-bottom" style="width: 100%; padding: 20px 0">
          <div class="wf flex-row start list active left">
            {{ value.Title || value.Name }}
          </div>
          <div class="wf flex-row start list left">
            {{ value.Paper.Name }}
          </div>
          <div class="wf flex-row start list left">
            {{ value.Training.Title }}
          </div>

          <div class="w200 flex-row start list">
            {{ value.PassedScore }}
          </div>
          <div class="w200 flex-row start list">
            <span v-if="value.TicketList && value.TicketList.length">{{ value.TicketList.length }}</span>
            <span v-else>无考试人员</span>
          </div>
          <div class="w200 flex-row start list">
            {{ value.CreateTime }}
          </div>
          <div class="wf flex-row start list">
            <div class="pointer active" @click="onGoDetail" v-if="IsDetail">详情</div>
            <div v-if="!GetDisabled('modify')">
              <a class="active" href="javascript:void(0)" @click="OnModify">编辑</a>
            </div>
            <div v-if="!GetDisabled('del')">
              <a class="active" href="javascript:void(0)" @click="OnDelete">删除</a>
            </div>
            <div>
              <a class="active" href="javascript:void(0)" @click="onExportResult">导出考试成绩</a>
            </div>
          </div>
        </div>
      </template>
      <div slot="button"></div>
    </mx-panel>
  </div>
</template>

<script>
import base from 'matrix.node.ui/libs/panels/base.js'
export default {
  props: {
    config: Object,
    value: Object,
    index: Number,
    role: String,
    roleField: String,
    name: String,
    selected: Object
  },
  mixins: [base],
  data() {
    return { IsModify: false, IsDelete: false }
  },
  computed: {
    SiteUrl() {
      return this.$matrix.Config.ImageSite
    },
    Config() {
      return Object.assign({ EventName: this.name ? this.name : 'TypeEvent', IsDark: false }, this.config)
    },
    IsDetail() {
      if (this.config.DetailView) return true
      return false
    },
    HasExamStudentField() {
      return this.$matrix.Models[this.config.Type].Fields.find((val) => {
        return val.Name === 'HasExamStudent'
      })
    }
  },
  methods: {
    OnEvent(e) {
      this.$emit('event', e)
    },
    onGoDetail() {
      let View = this.config.DetailView
      if (!View) return this.$matrix.ShowError('未配置详情视图')
      this.$emit('goview', {
        View: View,
        ViewType: '详情',
        Data: this.value,
        Role: this.config.Role,
        RoleField: this.config.RoleField
      })
    },
    onAddStudent() {
      console.log(this.value, 'value')
      this.$matrix.AddData(
        this.Context,
        {},
        {
          Type: 'Exam.CreateUsers',
          Role: this.config.Role,
          RoleField: this.config.RoleField
        },
        (data) => {
          this.$emit('event', {
            target: 'item',
            name: 'Reload'
          })
        },
        this.value
      )
    },
    onExportResult() {
      console.log(this.value)
      this.$matrix
        .AjaxGet3(
          'Exam.Ticket',
          'GetList',
          {
            Parent: this.value,
            GetTraining: true,
            GetParent: true,
            GetUsers: true,
            Page: 1,
            PageSize: 0,
            UsersSearchParams: {
              GetCompany: true,
              GetCategory: true
            },
            ExamState: [2, 3],
            ExamResult: [2, 3],
          },
          this.config.Role,
          this.config.RoleField
        )
        .then((data) => {
          if (data.Items.length === 0) return this.$matrix.ShowError('未找到考试人员')
          if (data.Items.length) {
            // let result = data.Items.reduce((t, n) => {
            //   let res = t.find((l) => {
            //     if (l.Users && l.Users.Company && l.Users.Company.Id) {
            //       return l.Users.Company.Id === n.Users.Company.Id
            //     }
            //   })

            //   if (!res) {
            //     res = {
            //       Company: n.Users.Company,
            //       Items: []
            //     }
            //     t.push(res)
            //   }
            //   res.Items.push(n)
            //   return t
            // }, [])

            let columns = [
              {
                Name: 'No',
                Title: '序号',
                Type: 'Int'
              },

              {
                Name: 'Exam',
                Title: '考试',
                Type: 'String'
              },

              {
                Name: 'UserName',
                Title: '考生',
                Type: 'String'
              },
              {
                Name: 'Company',
                Title: '所属单位',
                Type: 'String'
              },
              {
                Name: 'Category',
                Title: '人员类型',
                Type: 'String'
              },
              {
                Name: 'ExamState',
                Title: '考试状态',
                Type: 'String'
              },
              {
                Name: 'ExamResult',
                Title: '考试结果',
                Type: 'String'
              },
              {
                Name: 'ExamScore',
                Title: '考生分数',
                Type: 'Int'
              },
              {
                Name: 'ExamStartTime',
                Title: '考试开始时间',
                Type: 'DateTime'
              },
              {
                Name: 'ExamEndTime',
                Title: '考试结束时间',
                Type: 'DateTime'
              }
            ]
            let datas = data.Items.sort((a, b) => {
              return b.ExamScore - a.ExamScore
            }).map((item, index) => {
              return {
                No: index + 1,
                UserName: item.Users.NickName,
                Category: item.Users.Category && item.Users.Category.Id ? item.Users.Category.Name : '无',
                Company: item.Users.Company && item.Users.Company.Id ? item.Users.Company.Name : '无',
                Exam: item.Parent.Name,
                ExamScore: item.ExamScore,
                ExamState: item.ExamState === 1 ? '未考试' : item.ExamState === 2 ? '考试中' : '已结束',
                ExamResult: item.ExamResult === 1 ? '未考试' : item.ExamResult === 2 ? '考试通过' : '考试不通过',
                CreateTime: item.CreateTime,
                ExamStartTime:item.ExamStartTime,
                ExamEndTime:item.ExamEndTime

              }
            })
            let pages = []
            pages.push({
              name: '考生考试明细',
              data: this.$matrix.CreateExcelData(columns, datas)
            })
            this.$matrix.SaveAsExcel(pages, `${this.value.Name}考生考试结果`)
          }
        })
        .catch((e) => {
          this.$matrix.ShowError(e)
        })
    }
  }
}
</script>

<style scoped>
.wf {
  flex: 1;
}

.wf2 {
  flex: 2;
}

.border {
  border: 1px solid #eee;
}

.label_1,
.label_2,
.label_3 {
  border-radius: 4px;
  padding: 4px 6px;
  text-align: center;
}

.label_1 {
  background: #fbc451;

  color: #fff;
}

.label_2 {
  background: #a498cb;

  color: #fff;
}

.label_3 {
  background: #a7bba9;

  color: #fff;
}

.label_4 {
  background: #f49a71;

  color: #fff;
}

.label_5 {
  background: #6d72bb;

  color: #fff;
}

.active {
  color: #2d8cf0;
}

.text-line {
  text-decoration: line-through;
  color: gray;
}

span.button {
  color: #2d8cf0;
  cursor: pointer;
}

.image-box {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  opacity: 1;
  background-color: rgba(243, 246, 249, 1);
  padding: 4px;
}

.border-bottom {
  border-bottom: 1px solid #e9ebec;
}
</style>
